module.exports = {
  fetch: `query getEnvironments {
    environments (sortBy: "name.en") {
      id
      key
      name {
        en
        es
      }
      picture {
        url
      }
    }
  }`,
};
